import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Send, MessageSquare, X, Minus } from 'lucide-react';
export function Contact() {
  const [isOpen, setIsOpen] = useState(true);
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([{
    id: 1,
    text: 'Hi there! 👋 How can we help you today?',
    sender: 'agent'
  }]);
  const handleSend = (e: React.FormEvent) => {
    e.preventDefault();
    if (!message.trim()) return;
    setMessages([...messages, {
      id: Date.now(),
      text: message,
      sender: 'user'
    }]);
    setMessage('');
    // Mock reply
    setTimeout(() => {
      setMessages(prev => [...prev, {
        id: Date.now(),
        text: 'Thanks for reaching out! A member of our team will be with you shortly.',
        sender: 'agent'
      }]);
    }, 1000);
  };
  return <div className="min-h-[80vh] bg-[#FAF8F4] pt-32 pb-24 px-6 flex flex-col items-center" data-id="element-8056" data-mp="ab4l9dlls8y7">
      <div className="text-center mb-12" data-id="element-8057" data-mp="a9a8wnoedp5q">
        <h1 className="text-4xl md:text-5xl font-bold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-8058" data-mp="15g8aqxli8yos">
          Contact Us
        </h1>
        <p className="text-neutral-500 text-lg max-w-md mx-auto" data-id="element-8059" data-mp="19f7i0oupl7je">
          Have questions about Giga? We're here to help. Start a chat with our
          team below.
        </p>
      </div>

      {/* Mock Crisp-style Chat Widget */}
      <div className="w-full max-w-[380px] relative" data-id="element-8060" data-mp="mguf8b84nfw6">
        <AnimatePresence mode="wait" data-id="element-8061" data-mp="mi5k6edb6tov">
          {isOpen ? <motion.div key="chat-window" initial={{
          opacity: 0,
          y: 20,
          scale: 0.95
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 20,
          scale: 0.95
        }} transition={{
          duration: 0.2
        }} className="bg-white rounded-2xl shadow-[0_12px_40px_-12px_rgba(0,0,0,0.15)] border border-[#EAE4D9] overflow-hidden flex flex-col h-[500px]" data-id="element-8062" data-mp="qhwf8u9vbvz7">
              {/* Chat Header */}
              <div className="bg-[#EA580C] p-4 flex items-center justify-between text-white" data-id="element-8063" data-mp="1m6u2clj31zdh">
                <div className="flex items-center gap-3" data-id="element-8064" data-mp="1h8sc9gn8ozsi">
                  <div className="relative" data-id="element-8065" data-mp="1had42yi664mo">
                    <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center" data-id="element-8066" data-mp="1w5t4rmd98ys1">
                      <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/c9cswf4udjck7zyoebqqwd/63a18a4c-5d20-4ad2-ba5f-9334c775fe47/Vector.png" alt="Giga" className="w-5 h-5 object-contain brightness-0 invert" data-id="element-8067" data-mp="1r66nn1ub2ydy" />
                    </div>
                    <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-400 border-2 border-[#EA580C] rounded-full" data-id="element-8068" data-mp="1d6p00psqxr66" />
                  </div>
                  <div data-id="element-8069" data-mp="18f6z21qq3ql7">
                    <h3 className="font-bold text-sm" data-id="element-8070" data-mp="18dvu3yljkcsi">Giga Support</h3>
                    <p className="text-xs text-white/80" data-id="element-8071" data-mp="kp32uffv6t48">
                      Typically replies in a few minutes
                    </p>
                  </div>
                </div>
                <button onClick={() => setIsOpen(false)} className="w-8 h-8 rounded-full hover:bg-white/20 flex items-center justify-center transition-colors" data-id="element-8072" data-mp="2rdlmfv4t9a96">
                  <Minus size={18} data-id="element-8073" data-mp="2hggybpren4pq" />
                </button>
              </div>

              {/* Chat Messages */}
              <div className="flex-1 p-4 overflow-y-auto bg-[#FAF8F4] flex flex-col gap-4" data-id="element-8074" data-mp="2mf0l1sdtokj5">
                {messages.map(msg => <div key={msg.id} className={`flex ${msg.sender === 'user' ? 'justify-end' : 'justify-start'}`} data-id="element-8075" data-mp="3a4uxw9y5693e">
                    <div className={`max-w-[85%] rounded-2xl px-4 py-2.5 text-[15px] ${msg.sender === 'user' ? 'bg-[#EA580C] text-white rounded-br-sm' : 'bg-white border border-[#EAE4D9] text-[#2B211A] rounded-bl-sm shadow-sm'}`} data-id="element-8076" data-mp="3f2wfsrju02da">
                      {msg.text}
                    </div>
                  </div>)}
              </div>

              {/* Chat Input */}
              <div className="p-4 bg-white border-t border-[#EAE4D9]" data-id="element-8077" data-mp="1tqmj51jm542b">
                <form onSubmit={handleSend} className="relative flex items-center" data-id="element-8078" data-mp="1tojmhynygcom">
                  <input type="text" value={message} onChange={e => setMessage(e.target.value)} placeholder="Compose your message..." className="w-full bg-[#FAF8F4] border border-[#EAE4D9] rounded-full pl-4 pr-12 py-3 text-[15px] text-[#2B211A] focus:outline-none focus:border-[#EA580C] focus:ring-1 focus:ring-[#EA580C] transition-all" data-id="element-8079" data-mp="29zc24czeixjy" />
                  <button type="submit" disabled={!message.trim()} className="absolute right-2 w-8 h-8 rounded-full bg-[#EA580C] text-white flex items-center justify-center disabled:opacity-50 disabled:bg-neutral-300 transition-colors" data-id="element-8080" data-mp="2swn0lvd7lmyc">
                    <Send size={14} className="ml-0.5" data-id="element-8081" data-mp="2ixe52y2p409v" />
                  </button>
                </form>
                <div className="text-center mt-3" data-id="element-8082" data-mp="2ewkiq94witj3">
                  <a href="https://crisp.chat" target="_blank" rel="noopener noreferrer" className="text-[10px] font-medium text-neutral-400 hover:text-neutral-600 transition-colors flex items-center justify-center gap-1" data-id="element-8083" data-mp="17jagy8ish6cq">
                    Powered by Crisp
                  </a>
                </div>
              </div>
            </motion.div> : <motion.div key="chat-button" initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.9
        }} className="flex justify-center" data-id="element-8084" data-mp="3j7p09b9egsrf">
              <button onClick={() => setIsOpen(true)} className="flex items-center gap-3 bg-[#EA580C] hover:bg-[#D04D0A] text-white px-8 py-4 rounded-full font-bold text-lg transition-all shadow-lg shadow-orange-900/20 hover:shadow-xl hover:-translate-y-0.5" data-id="element-8085" data-mp="1qxde7h5qxom">
                <MessageSquare size={20} data-id="element-8086" data-mp="aozkn4rhimkc" />
                Chat with us
              </button>
            </motion.div>}
        </AnimatePresence>
      </div>
    </div>;
}